<template>
  <div id="JtLineChart">
    <v-chart ref="chart" class="jtchart" :option="chartSettings" autoresize />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { dashboardMethods } from '../dashboard/shared'
import JtBaseBarLineChart from './base/JtBaseBarLineChart.vue'

@Component({
  name: 'JtLineChart',
  mixins: [JtBaseBarLineChart],
  props: {
    centralTitle: {
      type: String,
      required: false,
      default: ''
    },
    centralTitleConst: {
      type: String,
      required: false,
      default: ''
    },
    shouldShowOverlappingBars: {
      type: Boolean,
      required: false,
      default: true
    }
  }
})
export default class JtLineChart extends Vue {
  created () {
    this.chartSettings.tooltip.trigger = 'axis'
    this.chartSettings.legend.icon = 'roundRect'
    this.chartSettings.xAxis.splitLine = {
      show: true
    }
    this.chartSettings.xAxis.boundaryGap = false
    this.chartSettings.title.text = this.centralTitle || (this.centralTitleConst ? this.$gettext(this.centralTitleConst) : '')
  }

  addAdditionalSeriesSettings (serieObject, idxForColorDefault) {
    serieObject.label.show = true
    serieObject.type = 'line'
    serieObject.symbolSize = 7
    serieObject.smooth = true

    const convertedColor = serieObject?.itemStyle?.color ? dashboardMethods.convertColorNameToHex(serieObject.itemStyle.color) : this.defaultEchartColorsForChartsSeries[idxForColorDefault]
    if (convertedColor.startsWith('#')) {
      serieObject.areaStyle = {
        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: `${convertedColor}97`
          },
          {
            offset: 1,
            color: `${convertedColor}00`
          }
        ])
      }
    }

    return serieObject
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#JtLineChart {
  height: 100%;
  width: 100%;
}
</style>
